import React from 'react'
import HeroRiveAnimation from '@/components/hero/HeroRiveAnimation'

import type { HeroBrandedProps } from './types'
import AppImage from '@/components/AppImage'

export function HeroBrandedInner({
  gradientType = 'light',
  brandColor = 'master',
  animationName,
  isActive = true,
  staticIllustration,
  imgLoading = 'eager',
  showAsset = true,
  textSlot,
}: HeroBrandedProps) {
  const gradientPositions = `gradient-angle-[60.66deg] ms:gradient-angle-[180deg] theme--gradient-${gradientType} ${gradientType === 'light' ? 'gradient-start-[53%] gradient-stop-[80%]' : 'gradient-start-[62%] gradient-stop-[94%]'}`
  const gradientClass = `relative theme--gradient-${gradientType} gradient--${brandColor} bg-theme text-fg ${gradientPositions}`

  return (
    <div
      className={`hero--branded-inner ${gradientClass} grid h-full grid-cols-1 grid-rows-1 justify-between overflow-hidden`}>
      {/* Spacer/min-height */}
      <div className="pointer-events-none aspect-[1856/650] max-w-[1756px] ms:hidden ms-up:grid-area-fill [@media(max-height:770px)]:aspect-[1856/600]"></div>

      {/* Text slot */}
      <div className="pointer-events-none z-20 flex flex-col items-start py-xxl ms:pb-0 ms-up:self-center ms-up:grid-area-fill">
        <div className="container m-up:px-xl l-up:px-xxl">
          <div className="pointer-events-auto ms-up:max-w-[min(50%,680px)]">
            {textSlot ? textSlot : null}
          </div>
        </div>
      </div>

      {/* Illustration */}
      {animationName || staticIllustration?.url ? (
        <div className="flex h-full w-full ms:-mt-m ms:h-[320px] ms-up:grid-area-fill">
          <div className="container relative flex ms:justify-center ms-up:justify-end">
            <div
              className={`z-0 aspect-[2900/1000] h-full ms:translate-x-[0%] ms-up:max-w-[140%] ms-up:translate-x-[30%]`}>
              <div className="hero--branded-blur ms:hidden"></div>

              <div className="absolute bottom-0 z-10 aspect-[2900/1000] w-full">
                {animationName === 'static' && staticIllustration?.url ? (
                  <AppImage
                    path={staticIllustration?.url}
                    alt={staticIllustration?.alt}
                    width={1904}
                    height={656}
                    transforms={{
                      dpr: '1.5', // fix this to 1.5 to avoid 2x images over 3800px wide
                      width: '1904',
                      height: '656',
                      quality: '90',
                    }}
                    srcSet={{
                      1904: { width: '1904', height: '656' },
                      1856: { width: '1856', height: '640' },
                      1624: { width: '1624', height: '560' },
                      1440: { width: '1440', height: '496' },
                      1280: { width: '1280', height: '441' },
                      960: { width: '960', height: '331' },
                      800: { width: '800', height: '276' },
                    }}
                    sizes="(min-width: 1960px) 1904px, (min-width: 1560px) calc(74.21vw + 464px), (min-width: 1120px) calc(60vw + 677px), (min-width: 780px) calc(113.75vw + 93px), 928px"
                    loading="eager"
                    fetchPriority="high"
                  />
                ) : (
                  <HeroRiveAnimation
                    animationName={animationName}
                    showAsset={showAsset}
                    isActive={isActive}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  )
}

export function HeroBranded(props: HeroBrandedProps) {
  return (
    <>
      <section className="hero--branded hero hero-padding bg-theme text-fg theme--base-0">
        <div className="overflow-hidden ms-up:rounded-lg">
          <HeroBrandedInner {...props} />
        </div>
      </section>
    </>
  )
}
